import { usePrinterHooks } from '@justomx/atlas-components'
import { useCallback, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { toastError, toastSuccess } from 'utils/toast'

const TEST_LABELS = {
  A: `
  ^XA
    ^CI28
    ^CFA,50
    ^FO50,50^FDTexto A: Orientación por defecto^FS
  ^XZ`,
  B: `
  ^XA
    ^FWB
    ^CI28
    ^CFA,50
    ^FO50,50^FDTexto B: 90° sentido horario^FS
  ^XZ`,
  C: `
  ^XA
    ^FWR
    ^CI28
    ^CFA,60

    ^FO470,16^GB120,650,10^FS
    ^FO470,16^GB120,650,60,B^FS
    ^FO490,45^FR^FDST-00000001-CO^FS

    ^FO470,930^GB120,250,10^FS
    ^FO470,930^GB120,250,60,B^FS
    ^FO490,955^FR^FD1/1^FS

    ^CFA,50
    ^FO380,25^FR^FDGeneral^FS

    ^FO300,18^GFA,378,378,7,,:::0FF,0FF8,:::::00F81MF,00F83MF,00F87MF8,::00F87CK0F8,:::00F87CI0F0F8,00F87C001F0F8,::0FF87C001F0F8,:::::00F87C001F0F8,::00F87CI0F0F8,00F87CK0F8,:::00F87MF8,::00F83MF8,00F81MF,0FF8,:::::0FF,,:::^FS
    ^FO295,90^FR^FDAB-LPN-000000A3^FS

    ^CFA,45
    ^FO210,20^GFA,378,378,7,,:::I0JFE,003KF8,007LF,007LFC1F,00NF3F8,00F8I01JF8,00F8J07IF8,00F8K0IF8,00F8K03FF8,00F8L0FF8,00F8L03F8,::::00CM03F8,P0FF8,O07FF8,J0EI01IF8,I0FFE007IF8,003IF01JF8,007IFC0FF3F8,00JFE0781F,01FC0FF06,03F003F8,07E001F8,07CI0FC07,078I07C1FC,0F8I03C3FE,0F8I03E3FF,0FJ03E7FF,:0FJ03E6,0FJ03E78,0F8I03E7C,0F8I03C7C,078I07C7E,07CI0FC7E,07E001F87E,03F003F87C,01FC0FF07C,00JFE078,007IFC07,003IF8,I0FFE,J0C,,:::^FS
    ^FO210,90^FR^FD3^FS

    ^FO120,18^GFA,378,378,7,,::::::03NFC,07NFE,0PF,:0F8J01F0F,0FK01E0F,0FK01E0FE,0FK01E0FF,0F001F81E0FF8,0F003FC1E0FF8,0F007FE1E0FF,0F00FFE1E0F,:0F00IF1E0F,0F00FFE1E0F,0F007FE1E0F,0F007FC1E0F,0F003F81E0F,0FI0F01E0F,0FK01E0F,:::::::::0FK01E0FF,0FK01E0FF8,:0FK01E0FF,0FK01E0FE,0FK01E0F,0F8J01F0F,0PF,:07NFE,03NFC,,::::::^FS
    ^FO118,90^FR^FD31/03/25-12:43^FS

    ^CFA,35

    ^FO30,18^GFA,378,378,7,,::::::::007F8,00FFC,00FFE,00IF,00IF8,00F8F8,00F87C,:00F83C,00F83E00FC,00F83E03FF,00F81E07FF8,00F81E0IFC,00F81F1IFE,00F81F1F83F,00F81F1F01F,00F81F3E00F,00F80F3E00F,:00F81F3E00F,00F81F1F01F,00F81F1F03F,00F81F1IFE,00F81F0IFC,00F81E07FF8,00F83E03FF,00F83E00FC,00F83C,00F87C,:00F8F8,00IF8,00IF,00FFE,00FFC,007F8,,::::::::^FS
    ^FO35,90^FR^FDJohn Doe^FS

    ^FO120,900
    ^BQN,2,10
    ^FDLA,AB-LPN-000000A3^FS
  ^XZ`
}

export const useTestPrinter = () => {
  const navigate = useNavigate()
  const { print } = usePrinterHooks()
  const [loading, setLoading] = useState(false)

  const goBack = useCallback(() => {
    navigate(-1)
  }, [navigate])

  const printSequentially = async (label: string) => {
    try {
      setLoading(true)
      await new Promise((resolve) => setTimeout(resolve, 5000))
      await print(label)
      toastSuccess('Imprimiendo etiqueta de prueba.')
    } catch (error) {
      console.error(error)
      toastError('Error al imprimir etiqueta de prueba.')
    } finally {
      setLoading(false)
    }

    goBack()
  }

  const printTest = (testId: string) => {
    const label = TEST_LABELS[testId]
    if (label) {
      printSequentially(label)
    }
  }

  return { loading, actions: { goBack, printTest } }
}
